(function(){
    window.vastaApplyScheduledPdpDiscount = function(cents, form, isSubscription) {
        var basePrice = Number(cents);
        var card = (form && form.querySelector('[data-buybox-discount]')) || document.querySelector('[data-buybox-discount]');
        if (!card || !Number.isFinite(basePrice)) return cents;
        var toggle = (form && form.querySelector('.subscription-toggle-input')) || document.querySelector('.subscription-toggle-input');
        var subscriptionActive = typeof isSubscription === 'boolean' ? isSubscription : Boolean(toggle && toggle.checked);
        if (subscriptionActive) return basePrice;
        var percent = Math.min(100, Math.max(0, Number(card.dataset.discountPercent) || 0));
        // Shopify floors the discount amount, so the discounted price rounds up
        return basePrice - Math.floor(basePrice * percent / 100);
    };
    const $productSwatch = $('#product-swatch');
    var SWATCH_DEBUG = false;
    /** When true, Splide "moved" should not push variant (programmatic go from variant). */
    var splideGoFromVariantChange = false;
    /** >0 while variant id is updated from Splide slide navigation (must not call productSplide.go). */
    var suppressVariantMediaSliderDepth = 0;
    var swatchDebugCounter = 0;
    var secondSwatchTransitionLock = {
        active: false,
        value: null,
        expiresAt: 0
    };
    var pdpSkipInitialMediaSync = false;

    function swatchLog(label, payload) {
        if (!SWATCH_DEBUG || typeof console === 'undefined') {
            return;
        }
        if (typeof payload === 'undefined') {
            console.log('[SWATCH_DEBUG]', label);
        } else {
            console.log('[SWATCH_DEBUG]', label, payload);
        }
    }

    function getCurrentSwatchSnapshot($scope) {
        var snapshot = [];
        var $targetScope = ($scope && $scope.length) ? $scope : $productSwatch;

        $targetScope.find('.swatch-type').each(function() {
            var $swatch = $(this);
            snapshot.push({
                index: parseInt($swatch.attr('data-index'), 10) || null,
                type: $swatch.attr('data-type') || null,
                radioValue: $swatch.find('.swatch-variant-value:checked').first().val() || null,
                selectValue: $swatch.find('.jq-product-variant').first().val() || null
            });
        });

        return snapshot;
    }

    function enableSecondSwatchTransitionLock(value, durationMs) {
        secondSwatchTransitionLock.active = true;
        secondSwatchTransitionLock.value = value || null;
        secondSwatchTransitionLock.expiresAt = Date.now() + (durationMs || 280);
        swatchLog('second swatch lock enabled', {
            value: secondSwatchTransitionLock.value,
            expiresAt: secondSwatchTransitionLock.expiresAt
        });
    }

    function disableSecondSwatchTransitionLock() {
        if (secondSwatchTransitionLock.active) {
            swatchLog('second swatch lock disabled', {
                value: secondSwatchTransitionLock.value
            });
        }
        secondSwatchTransitionLock.active = false;
        secondSwatchTransitionLock.value = null;
        secondSwatchTransitionLock.expiresAt = 0;
    }

    function isSecondSwatchTransitionLockActive() {
        if (!secondSwatchTransitionLock.active) {
            return false;
        }
        if (Date.now() > secondSwatchTransitionLock.expiresAt) {
            disableSecondSwatchTransitionLock();
            return false;
        }
        return true;
    }
    function initPrevBreedFromForm($form) {
        if (!$form || !$form.length) {
            return;
        }
        var $first = $form.find('.swatch-type[data-index="1"]').first();
        if (!$first.length) {
            return;
        }
        var opts = get_selected_options_by_swatch($form);
        if (opts[0]) {
            $first.data('vasta-prev-breed', opts[0]);
        }
    }

    function applyVariantDomToSwatchUi($form, $variantOption) {
        if (!$form.length || !$variantOption || !$variantOption.length) {
            return;
        }
        var raw = ($variantOption.attr('data-options') || '');
        if (!raw) {
            return;
        }
        var parts = raw.split(',');
        var $swatches = $form.find('.swatch-type').sort(function(a, b) {
            return (parseInt($(a).attr('data-index'), 10) || 0) - (parseInt($(b).attr('data-index'), 10) || 0);
        });
        $swatches.each(function(i) {
            var val = (parts[i] || '').trim();
            if (!val) {
                return;
            }
            var $sw = $(this);
            var $radio = $sw.find('.swatch-variant-value').filter(function() {
                return ($(this).val() || '') === val;
            });
            if ($radio.length) {
                $sw.find('.swatch-variant-value').prop('checked', false);
                $radio.prop('checked', true);
            }
            var $sel = $sw.find('.jq-product-variant').first();
            if ($sel.length && $sel.find('option').filter(function() {
                return ($(this).val() || '') === val;
            }).length) {
                $sel.val(val);
            }
        });
    }

    function forceVariantByOptionValues($allVariants, optionValues) {
        if (!$allVariants || !$allVariants.length || !optionValues || !optionValues.length) {
            return false;
        }

        var encoded = optionValues.join(',').replace(/"/g, '\\"').replace(/'/g, "\\'");
        var $match = $allVariants.find('option[data-options="' + encoded + '"]').first();

        if (!$match.length) {
            $match = $allVariants.find('option').filter(function() {
                var values = (($(this).attr('data-options') || '') + '').split(',');
                if (values.length !== optionValues.length) {
                    return false;
                }
                for (var i = 0; i < optionValues.length; i++) {
                    if ((values[i] || '').toString().trim() !== (optionValues[i] || '').toString().trim()) {
                        return false;
                    }
                }
                return true;
            }).first();
        }

        if (!$match.length) {
            swatchLog('forceVariantByOptionValues no match', { optionValues: optionValues });
            return false;
        }

        var nextId = $match.val();
        var currentId = $allVariants.val();
        swatchLog('forceVariantByOptionValues apply', {
            optionValues: optionValues,
            currentId: currentId,
            nextId: nextId
        });

        if (currentId !== nextId) {
            $allVariants.val(nextId).trigger('change');
        } else {
            $allVariants.trigger('change');
        }
        return true;
    }

    /**
    * @param variants
    */
    function prepare_variants(variants) {
        var variations = [];
        variants.each(function () {
            variations.push($(this).val());
        });
        return variations;
    }
    /**
    *
    */
    function get_variation(all_variants, options) {
        var variations = [];
        var raw_options = options.slice();
        options = options.join(',').replace(/"/g, '\\"').replace(/'/g, "\\'");
        variations = $(all_variants).find('option[data-options="' + options + '"]');
        swatchLog('get_variation lookup', {
            rawOptions: raw_options,
            encodedOptions: options,
            matches: variations.length,
            currentVariantId: $(all_variants).val(),
            matchedVariantId: variations.length ? variations.val() : null
        });

        if (variations.length === 0) {
            variations = $(all_variants).find('option').filter(function() {
                var dataOptions = ($(this).attr('data-options') || '').split(',');
                if (dataOptions.length !== raw_options.length) {
                    return false;
                }

                for (var i = 0; i < raw_options.length; i++) {
                    var expected = (raw_options[i] || '').toString().trim();
                    var current = (dataOptions[i] || '').toString().trim();
                    if (current !== expected) {
                        return false;
                    }
                }

                return true;
            }).first();
        }

        if (variations.length > 0) {
            var nextVariantId = variations.val();
            // Always notify listeners (gallery / Splide) even when the id was already set —
            // e.g. breed change + second swatch reset can leave .all-variant correct while the
            // slider still shows the previous pack's slide after an intermediate update.
            $(all_variants).val(nextVariantId).trigger('change');
            return true;
        }
        return false;
    }
    /**
    * Check this function
    */
    function filter_variants(Product, options, option_current, swatch_index, enable_atc_button, $scope, breedJustChanged) {
        var $root = ($scope && $scope.length) ? $scope : $(document);
        var swatch_type = $root.find('.swatch-type[data-index="' + (swatch_index + 1) + '"]');
        if (!swatch_type.length) {
            return;
        }
        var swatchTypeIndex = parseInt(swatch_type.attr('data-index'), 10) || 0;
        var forceFirstForTargetSwatch = !!breedJustChanged && swatchTypeIndex === 2;
        if (typeof Product.variations[option_current] !== 'undefined'){
            change_swatch_variants( swatch_type, Object.keys(Product.variations[option_current]), enable_atc_button, forceFirstForTargetSwatch );
        }else if (typeof Product.variations[options[0]] !== 'undefined' && typeof Product.variations[options[0]][option_current] !== 'undefined'){
            change_swatch_variants( swatch_type, Product.variations[options[0]][option_current], enable_atc_button, forceFirstForTargetSwatch );
        }
    }
    /**
    *
    */
    function change_swatch_variants(swatch, variants, enable_atc_button, forceFirstAvailable) {
        forceFirstAvailable = !!forceFirstAvailable;
        var first_select_value,
            swatch_select = swatch.find('.product-variant option'),
            swatch_radio  = swatch.find('.swatch-variant-value');
        var swatchTypeIndex = parseInt(swatch.attr('data-index'), 10);
        var shouldForceLockedSecondSwatch = !forceFirstAvailable && swatchTypeIndex === 2 && isSecondSwatchTransitionLockActive() && !!secondSwatchTransitionLock.value;
        var swatch_select_parent = swatch.find('.product-variant');
        var current_select_value = swatch_select_parent.val();
        var current_radio = swatch_radio.filter(':checked');
        var current_radio_value = current_radio.length ? current_radio.val() : '';
        $('.product-variant', swatch).prop('disabled', false);
        swatch_radio.parent().addClass('swatch-disabled');
        // BEGIN_TAG_SELECT
            swatch_select.prop({
                disabled: true,
                checked: false
            });
            swatch_select.each(function(){
                if (variants.indexOf($(this).val()) > -1) {
                    $(this).prop('disabled', false);
                }
            });
            first_select_value = swatch_select.filter(':not(:disabled):first').val();
            if (enable_atc_button) {
                if (forceFirstAvailable) {
                    swatch_select_parent.val(first_select_value).trigger('change');
                } else if (shouldForceLockedSecondSwatch && variants.indexOf(secondSwatchTransitionLock.value) > -1) {
                    swatch_select_parent.val(secondSwatchTransitionLock.value).trigger('change');
                } else if (current_select_value && variants.indexOf(current_select_value) > -1) {
                    swatch_select_parent.val(current_select_value).trigger('change');
                } else {
                    swatch_select_parent.val(first_select_value).trigger('change');
                }
            }
        // END_TAG_SELECT
        // BEGIN_RADIO_BUTTON
            swatch_radio.prop({
                disabled: true,
                checked: false
            });
            swatch_radio.each(function(i){
                if (variants.indexOf($(this).val()) > -1) {
                    $(this).prop('disabled', false);
                    $(this).parent().removeClass('swatch-disabled');
                }
            });
            if (enable_atc_button) {
                if (forceFirstAvailable) {
                    swatch_radio.filter(':not(:disabled):first').trigger('click');
                } else if (shouldForceLockedSecondSwatch && variants.indexOf(secondSwatchTransitionLock.value) > -1) {
                    swatch_radio.filter('[value="' + secondSwatchTransitionLock.value + '"]').trigger('click');
                } else if (current_radio_value && variants.indexOf(current_radio_value) > -1) {
                    swatch_radio.filter('[value="' + current_radio_value + '"]').trigger('click');
                } else {
                    swatch_radio.filter(':not(:disabled):first').trigger('click');
                }
            }
        // END_RADIO_BUTTON
        swatch.prev().find('.choose-option').removeClass('choose-option');
    }
    function choose_before_option( i ) {
        $('.swatch-type[data-index="'+ i +'"] .swatch-element').on('click', function(){ 
            var swatch_checkeds = $('.swatch-type[data-index="'+ (i - 1) +'"] input:checked').length;
            var swatch_selects = typeof $('.swatch-type[data-index="'+ (i - 1) +'"] select').val() !== 'undefined' && $('.swatch-type[data-index="'+ (i - 1) +'"] select').val() !== '';
            $('.swatch-type.swatch-elements-wrapper').removeClass('choose-option');
            if (swatch_checkeds === 0 && swatch_selects === false) {
                $('.swatch-type[data-index="'+ (i - 1) +'"] .swatch-elements-wrapper').addClass('choose-option');
            }
        });
    }
    function you_save(compare_at_price,price){
        let you_save = $('.you-save-price');
        if (!you_save.length || document.querySelector('.custom-subscription-widget-wrapper')) {
            you_save.hide();
            return;
        }
        let value = 100 - ((price * 100)/compare_at_price);
        let percent_selector = $('.compare_percent');
        let price_selector = $('.you-save-price .money');
        if(compare_at_price > price){
            percent_selector.html(" (" + value.toFixed(2) + "%)");
            price_selector.html(VastaShop.formatMoney(compare_at_price-price));
            you_save.fadeIn(function(){you_save.show();});
        }else{
            you_save.fadeOut(function(){you_save.hide();});
        }
    }
    function reset_second_swatch_to_first($scope) {
        var $secondSwatch = $scope.find('.swatch-type[data-index="2"]');
        if (!$secondSwatch.length) {
            return false;
        }

        var $radioOptions = $secondSwatch.find('.swatch-variant-value');
        var $enabledRadioOptions = $radioOptions.filter(':not(:disabled)');
        var $radioToSelect = $enabledRadioOptions.first();

        if ($radioToSelect.length) {
            var radioChanged = !$radioToSelect.is(':checked');
            if (radioChanged) {
                $radioOptions.prop('checked', false);
                $radioToSelect.prop('checked', true).trigger('click').trigger('change');
            }
            var $selectForSecondSwatch = $secondSwatch.find('.product-variant').first();
            if ($selectForSecondSwatch.length && $selectForSecondSwatch.val() !== $radioToSelect.val()) {
                $selectForSecondSwatch.val($radioToSelect.val());
            }
            return true;
        }

        var $select = $secondSwatch.find('.product-variant').first();
        if (!$select.length) {
            return false;
        }

        var $enabledOptions = $select.find('option:not(:disabled):not([value=""])');
        var $optionToSelect = $enabledOptions.first();
        if ($optionToSelect.length) {
            if ($select.val() !== $optionToSelect.val()) {
                $select.val($optionToSelect.val()).trigger('change');
            }
            return true;
        }
        return false;
    }

    /**
     * Parse bag / chew counts from option strings (breed change + gallery sync).
     * Kept independent of normalizeLooseText so it runs before that helper is defined.
     */
    function parsePackTierFromLabel(label) {
        var n = (label || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
        var bagMatch = n.match(/\b(\d+)\s*bags?\b/);
        var chewMatch = n.match(/\b(\d+)\s*chews?\b/);
        return {
            bags: bagMatch ? parseInt(bagMatch[1], 10) : null,
            chews: chewMatch ? parseInt(chewMatch[1], 10) : null
        };
    }

    var packQuantitySyncDepth = 0;

    function getPackSwatchOptionIndex() {
        var optionCount = parseInt($productSwatch.attr('data-option-count'), 10);
        if (isNaN(optionCount) || optionCount < 1) {
            if (typeof VastaShop !== 'undefined' && VastaShop.Product && VastaShop.Product.current) {
                optionCount = VastaShop.Product.current.options.length;
            } else {
                optionCount = 1;
            }
        }
        return optionCount > 1 ? 2 : 1;
    }

    function getPackCountTypeFromTier(tier) {
        if (tier.chews !== null) {
            return 'chews';
        }
        if (tier.bags !== null) {
            return 'bags';
        }
        return null;
    }

    function formHasPackTierOptions($form) {
        if (!$form || !$form.length) {
            return false;
        }
        var packIdx = getPackSwatchOptionIndex();
        var $sw = $form.find('.swatch-type[data-index="' + packIdx + '"]');
        if (!$sw.length) {
            return false;
        }
        var hasTier = false;
        $sw.find('.swatch-variant-value, .jq-product-variant option').each(function() {
            var tier = parsePackTierFromLabel($(this).val());
            if (tier.bags !== null || tier.chews !== null) {
                hasTier = true;
                return false;
            }
        });
        return hasTier;
    }

    function getSelectedPackTier($form) {
        var packIdx = getPackSwatchOptionIndex() - 1;
        var options = get_selected_options_by_swatch($form);
        var label = options[packIdx] || '';
        if (!label) {
            var parts = ($form.find('.all-variant option:selected').attr('data-options') || '').split(',');
            label = (parts[packIdx] || '').trim();
        }
        return parsePackTierFromLabel(label);
    }

    function getPackUnitCount(tier) {
        var countType = getPackCountTypeFromTier(tier);
        if (countType === 'chews') {
            return tier.chews || 1;
        }
        if (countType === 'bags') {
            return tier.bags || 1;
        }
        return 1;
    }

    function findPackOptionLabelForCount($form, desiredCount, countType) {
        var packIdx = getPackSwatchOptionIndex();
        var $sw = $form.find('.swatch-type[data-index="' + packIdx + '"]');
        var values = [];
        $sw.find('.swatch-element:not(.swatch-disabled) .swatch-variant-value').each(function() {
            values.push($(this).val());
        });
        if (!values.length) {
            $sw.find('.jq-product-variant option:not(:disabled)').each(function() {
                if ($(this).val()) {
                    values.push($(this).val());
                }
            });
        }
        for (var i = 0; i < values.length; i++) {
            var tier = parsePackTierFromLabel(values[i]);
            var count = countType === 'chews' ? tier.chews : tier.bags;
            if (count === desiredCount) {
                return values[i];
            }
        }
        return null;
    }

    function formatPackCountLabel(count, countType) {
        if (countType === 'chews') {
            return count + (count > 1 ? ' CHEWS' : ' CHEW');
        }
        return count + (count > 1 ? ' BAGS' : ' BAG');
    }

    function formUsesChewsAtcLabel($form) {
        var packIdx = getPackSwatchOptionIndex();
        return $form.find('.swatch-type[data-index="' + packIdx + '"]').hasClass('swatch-type--chews');
    }

    function parseChewsCountFromText(text) {
        var normalized = normalizeLooseText(text);
        var chewMatch = normalized.match(/(\d+)\s*chews?/);
        return chewMatch ? parseInt(chewMatch[1], 10) : null;
    }

    function getChewsPerBagFromPackCard($form, packLabel) {
        if (!packLabel) {
            return null;
        }
        var packIdx = getPackSwatchOptionIndex();
        var $sw = $form.find('.swatch-type[data-index="' + packIdx + '"]');
        var $radio = $sw.find('.swatch-variant-value').filter(function() {
            return ($(this).val() || '') === packLabel;
        }).first();
        if (!$radio.length) {
            return null;
        }
        var $card = $radio.closest('.swatch-element-chews');
        if (!$card.length) {
            return null;
        }
        var detailText = $card.find('.swatch-chews__oil-volume, .swatch-chews__chews').first().text();
        return parseChewsCountFromText(detailText);
    }

    function getChewsPerBagFromSelectedPack($form) {
        var packIdx = getPackSwatchOptionIndex();
        var $sw = $form.find('.swatch-type[data-index="' + packIdx + '"]');
        var packLabel = $sw.find('.swatch-variant-value:checked').first().val();
        return getChewsPerBagFromPackCard($form, packLabel);
    }

    function updatePdpAddToCartPackLabel($form, bagCount, countType, packLabelOpt) {
        bagCount = parseInt(bagCount, 10) || 1;
        var text;

        if (formUsesChewsAtcLabel($form)) {
            var chewsPerBag = packLabelOpt
                ? getChewsPerBagFromPackCard($form, packLabelOpt)
                : getChewsPerBagFromSelectedPack($form);
            if (chewsPerBag) {
                text = formatPackCountLabel(chewsPerBag * bagCount, 'chews');
            } else {
                text = formatPackCountLabel(bagCount, 'bags');
            }
        } else if (countType === 'chews') {
            text = formatPackCountLabel(bagCount, 'chews');
        } else {
            text = formatPackCountLabel(bagCount, 'bags');
        }

        getPdpForms().find('.btn-add-tocart .btn-items').html(text);
    }

    function getPdpForms() {
        var $forms = $('form.jq-cart-add-product.form-add-to-cart');
        return $forms.length ? $forms : $('form.jq-cart-add-product');
    }

    function setPdpQuantityDisplay(count) {
        count = parseInt(count, 10);
        if (isNaN(count) || count < 1) {
            count = 1;
        }
        getPdpForms().find('.product-quantity-wrapper > .quantity').val(count);
        if (typeof VastaShop !== 'undefined' && VastaShop.Variables && VastaShop.Variables._quantity) {
            VastaShop.Variables._quantity.val(count);
        }
    }

    function pdpQuantityMatchesPackTier($form) {
        if (!formHasPackTierOptions($form)) {
            return false;
        }
        var lineQty = parseInt($form.find('.product-quantity-wrapper > .quantity').val(), 10) || 1;
        return getPackUnitCount(getSelectedPackTier($form)) === lineQty;
    }

    function resolveFormFromContext(contextEl) {
        var $form = contextEl ? $(contextEl).closest('form.jq-cart-add-product') : $();
        if ($form.length) {
            return $form.first();
        }
        return getPdpForms().first();
    }

    function selectPackOptionOnForm($form, packLabel) {
        var packIdx = getPackSwatchOptionIndex();
        var options = get_selected_options_by_swatch($form);
        while (options.length < packIdx) {
            options.push('');
        }
        options[packIdx - 1] = packLabel;

        var $allVariants = $form.find('.all-variant');
        if (forceVariantByOptionValues($allVariants, options)) {
            applyVariantDomToSwatchUi($form, $allVariants.find('option:selected'));
            return true;
        }

        var $sw = $form.find('.swatch-type[data-index="' + packIdx + '"]');
        var $radio = $sw.find('.swatch-variant-value').filter(function() {
            return $(this).val() === packLabel && !$(this).prop('disabled');
        }).first();

        if ($radio.length) {
            $sw.find('.swatch-variant-value').prop('checked', false);
            $radio.prop('checked', true);
            $radio.trigger('change');
            return true;
        }

        var $sel = $sw.find('.jq-product-variant').first();
        if ($sel.length && $sel.find('option').filter(function() {
            return $(this).val() === packLabel && !$(this).prop('disabled');
        }).length) {
            $sel.val(packLabel).trigger('change');
            return true;
        }
        return false;
    }

    function syncPdpToBagCount($form, desiredCount) {
        if (!$form || !$form.length || !formHasPackTierOptions($form)) {
            return { handled: false };
        }

        desiredCount = parseInt(desiredCount, 10);
        if (isNaN(desiredCount) || desiredCount < 1) {
            desiredCount = 1;
        }

        var tier = getSelectedPackTier($form);
        var countType = getPackCountTypeFromTier(tier) || 'bags';
        var currentBags = getPackUnitCount(tier);

        if (desiredCount === currentBags) {
            setPdpQuantityDisplay(desiredCount);
            updatePdpAddToCartPackLabel($form, desiredCount, countType);
            return { handled: true, synced: true, bagCount: desiredCount, cartQuantity: 1 };
        }

        var packLabel = findPackOptionLabelForCount($form, desiredCount, 'bags');

        if (packLabel) {
            packQuantitySyncDepth += 1;
            try {
                setPdpQuantityDisplay(desiredCount);
                selectPackOptionOnForm($form, packLabel);
            } finally {
                packQuantitySyncDepth -= 1;
            }
            updatePdpAddToCartPackLabel($form, desiredCount, countType, packLabel);
            return { handled: true, synced: true, bagCount: desiredCount, cartQuantity: 1 };
        }

        var lineQty = parseInt($form.find('.product-quantity-wrapper > .quantity').val(), 10) || 1;
        var bagUnits = getPackUnitCount(tier) * lineQty;
        updatePdpAddToCartPackLabel($form, bagUnits, countType);
        return { handled: true, synced: false, bagCount: bagUnits, cartQuantity: lineQty };
    }

    window.vastaFormHasPackTierOptions = function(contextEl) {
        return formHasPackTierOptions(resolveFormFromContext(contextEl));
    };

    window.vastaGetSelectedPackUnitCount = function(contextEl) {
        return getPackUnitCount(getSelectedPackTier(resolveFormFromContext(contextEl)));
    };

    window.vastaGetPdpLineQuantityForPricing = function(contextEl) {
        var $form = resolveFormFromContext(contextEl);
        if (!formHasPackTierOptions($form)) {
            return null;
        }
        var lineQty = parseInt($form.find('.product-quantity-wrapper > .quantity').val(), 10) || 1;
        var tierBags = getPackUnitCount(getSelectedPackTier($form));
        if (lineQty === tierBags || findPackOptionLabelForCount($form, lineQty, 'bags')) {
            return 1;
        }
        return lineQty;
    };

    window.vastaGetPdpCartSubmitQuantity = function(formEl) {
        var $form = formEl ? $(formEl) : getPdpForms().first();
        if (!pdpQuantityMatchesPackTier($form)) {
            return parseInt($form.find('.product-quantity-wrapper > .quantity').val(), 10) || 1;
        }
        return 1;
    };

    window.vastaRefreshPdpPackPricing = function(contextEl) {
        var $form = resolveFormFromContext(contextEl);
        if (!$form.length) {
            return;
        }
        var qty = parseInt($form.find('.product-quantity-wrapper > .quantity').val(), 10) || 1;
        if (typeof window.refreshSubscriptionDisplayPrices === 'function') {
            var toggle = $form.find('.subscription-toggle-input')[0] ||
                document.querySelector('.subscription-toggle-input');
            if (toggle && toggle.checked) {
                window.refreshSubscriptionDisplayPrices($form.find('.all-variant').val(), $form[0]);
                return;
            }
        }
        var price = parseInt($form.find('.all-variant option:selected').attr('data-price'), 10) || 0;
        price = window.vastaApplyScheduledPdpDiscount(price, $form[0]);
        var lineQty = 1;
        if (typeof window.vastaGetPdpLineQuantityForPricing === 'function') {
            var packLineQty = window.vastaGetPdpLineQuantityForPricing(contextEl);
            if (packLineQty !== null) {
                lineQty = packLineQty;
            }
        } else if (!formHasPackTierOptions($form)) {
            lineQty = qty;
        }
        if (typeof VastaShop !== 'undefined' && VastaShop.formatMoney) {
            $('.btn-add-tocart > .btn-money').html(VastaShop.formatMoney(lineQty * price));
        }
    };

    window.vastaAdjustPdpBagCount = function(delta, contextEl) {
        var $form = resolveFormFromContext(contextEl);
        if (!formHasPackTierOptions($form)) {
            return false;
        }
        var desired = Math.max(1, getPackUnitCount(getSelectedPackTier($form)) + delta);
        var result = syncPdpToBagCount($form, desired);
        return !!(result.handled && result.synced);
    };

    window.vastaSyncPdpBagCountFromInput = function(desiredCount, contextEl) {
        var result = syncPdpToBagCount(resolveFormFromContext(contextEl), desiredCount);
        return !!result.handled;
    };

    window.vastaRefreshPdpPackDisplay = function(contextEl) {
        var $form = resolveFormFromContext(contextEl);
        if (!formHasPackTierOptions($form)) {
            return;
        }
        var tier = getSelectedPackTier($form);
        var countType = getPackCountTypeFromTier(tier) || 'bags';
        var displayBags = parseInt($form.find('.product-quantity-wrapper > .quantity').val(), 10) ||
            getPackUnitCount(tier);
        updatePdpAddToCartPackLabel($form, displayBags, countType);
    };

    function sync_variant_from_scope($scope, $allVariants, totalOptions) {
        var selectedOptions = get_selected_options_by_swatch($scope);
        var hasCompleteSelection = selectedOptions.length === totalOptions && selectedOptions.every(function(optionValue) {
            return typeof optionValue !== 'undefined' && optionValue !== null && optionValue !== '';
        });

        if (hasCompleteSelection && get_variation($allVariants, selectedOptions)) {
            $allVariants.trigger('change');
            return true;
        }

        return false;
    }
    function get_selected_options_by_swatch($scope) {
        var selectedOptions = [];
        var $swatches = $scope.find('.swatch-type').sort(function(a, b) {
            return (parseInt($(a).attr('data-index'), 10) || 0) - (parseInt($(b).attr('data-index'), 10) || 0);
        });

        $swatches.each(function() {
            var $swatch = $(this);
            var radioValue = $swatch.find('.swatch-variant-value:checked').first().val();
            if (typeof radioValue !== 'undefined' && radioValue !== null && radioValue !== '') {
                selectedOptions.push(radioValue);
                return;
            }

            var selectValue = $swatch.find('.jq-product-variant').first().val();
            if (typeof selectValue !== 'undefined' && selectValue !== null && selectValue !== '') {
                selectedOptions.push(selectValue);
            }
        });

        return selectedOptions;
    }

    function isPdpSubscriptionActive($sourceForm) {
        var toggle = null;

        if ($sourceForm && $sourceForm.length) {
            toggle = $sourceForm.find('.subscription-toggle-input')[0];
        }
        if (!toggle) {
            toggle = document.querySelector('.product-container.no-mobile .subscription-toggle-input');
        }
        if (!toggle) {
            toggle = document.querySelector('.subscription-toggle-input');
        }

        return toggle ? toggle.checked : false;
    }

    function syncPageVariantSelects(variantId, $sourceSelect) {
        if (!variantId) {
            return;
        }
        var variantIdStr = String(variantId);
        $('.all-variant').each(function() {
            if ($sourceSelect && this === $sourceSelect[0]) {
                return;
            }
            if ($(this).val() !== variantIdStr) {
                $(this).val(variantIdStr);
            }
        });
    }

    function scheduleSubscriptionPriceRefresh(variantId, formEl) {
        if (typeof window.refreshSubscriptionDisplayPrices !== 'function') {
            return;
        }
        window.refreshSubscriptionDisplayPrices(variantId, formEl || null);
    }

    var _quantity = $('.product-quantity-wrapper > .quantity'),
        _product_featured = $('.jq-featured-slider'),
        _add_to_cart_value = $('.btn-add-tocart > .btn-money'),
        _add_to_cart_items = $('.btn-add-tocart > .btn-items'),
        _product_options = $('.jq-swatch-element,.jq-product-variant'),
        _current_price = $('.product-price .current-price'),
        _current_compare_price = $('.product-price .compare-price, .new-price-discounts-wrapper .compare-price'),
        _new_current_price = $('.new-product-price .jq-new-price'),
        _new_current_compare_price = $('.new-product-price .jq-new-compare-price'),
        _choosed_variant = $('.all-variant'),
        _price = $(':selected', _choosed_variant).attr('data-price'),
        _global_variant_compare_at_price = $(':selected', $('.all-variant')).attr('data-compare-at-price') === "" ? "" : VastaShop.formatMoney($(':selected', $('.all-variant')).attr('data-compare-at-price'));
     
    // Product Options
    _product_options.change(function(){
        var debugId = ++swatchDebugCounter;
        var $currentForm = $(this).closest('form');
        var $currentSwatchScope = $currentForm.length ? $currentForm : $productSwatch;
        var $currentAllVariants = $currentForm.length ? $currentForm.find('.all-variant') : _choosed_variant;
        var currentSwatchIndex = parseInt($(this).attr('data-swatch-index'), 10);
        var currentSwatchTypeIndex = parseInt($(this).closest('.swatch-type').attr('data-index'), 10);
        var breedSelectionChanged = false;
        if (currentSwatchTypeIndex === 1) {
            var selectedBreedNow = $(this).val();
            var $breedSwatchType = $currentSwatchScope.find('.swatch-type[data-index="1"]').first();
            var prevBreed = $breedSwatchType.data('vasta-prev-breed');
            breedSelectionChanged =
                typeof prevBreed === 'undefined' ||
                prevBreed === null ||
                prevBreed === '' ||
                prevBreed !== selectedBreedNow;
            if (breedSelectionChanged) {
                $breedSwatchType.data('vasta-prev-breed', selectedBreedNow);
            }
        }
        if (currentSwatchTypeIndex === 2 && isSecondSwatchTransitionLockActive()) {
            var lockedValue = secondSwatchTransitionLock.value;
            var incomingValue = $(this).val();
            if (lockedValue && incomingValue !== lockedValue) {
                swatchLog('blocked stale second swatch change #' + debugId, {
                    incomingValue: incomingValue,
                    lockedValue: lockedValue,
                    swatchSnapshot: getCurrentSwatchSnapshot($currentSwatchScope)
                });
                return false;
            }
        }
        var totalOptions = VastaShop.Product.current.options.length;
        var options = get_selected_options_by_swatch($currentSwatchScope);
        var hasCompleteSelection = options.length === totalOptions && options.every(function(optionValue) {
            return typeof optionValue !== 'undefined' && optionValue !== null && optionValue !== '';
        });
        swatchLog('product_options.change START #' + debugId, {
            triggerValue: $(this).val(),
            triggerSwatchIndex: currentSwatchIndex,
            triggerSwatchTypeIndex: currentSwatchTypeIndex,
            options: options,
            hasCompleteSelection: hasCompleteSelection,
            totalOptions: totalOptions,
            swatchSnapshotBefore: getCurrentSwatchSnapshot($currentSwatchScope),
            allVariantBefore: {
                id: $currentAllVariants.val(),
                dataOptions: $currentAllVariants.find('option:selected').attr('data-options') || null
            }
        });
        $(this).parent().removeClass('choose-option');
        var breedJustChanged = currentSwatchTypeIndex === 1 && breedSelectionChanged;
        if (breedJustChanged && hasCompleteSelection && $currentForm.length) {
            // Before filter_variants: nested second-swatch updates must not resolve the gallery via
            // URL/thumb heuristics (old pack still selected for one tick).
            $currentForm.data('vasta-force-breed-featured-media', true);
        }
        // Filter Variants
        filter_variants(
            VastaShop.Product.current,
            options,
            $(this).val(),
            currentSwatchIndex,
            hasCompleteSelection,
            $currentSwatchScope,
            breedJustChanged
        );

        if (currentSwatchTypeIndex === 1) {
            if (!breedSelectionChanged) {
                disableSecondSwatchTransitionLock();
            } else {
                reset_second_swatch_to_first($currentSwatchScope);
                disableSecondSwatchTransitionLock();
            }
        }

        options = get_selected_options_by_swatch($currentSwatchScope);
        hasCompleteSelection = options.length === totalOptions && options.every(function(optionValue) {
            return typeof optionValue !== 'undefined' && optionValue !== null && optionValue !== '';
        });

        if (breedJustChanged && hasCompleteSelection && $currentForm.length) {
            // Nested second-swatch handling consumes the first flag on all-variant.change; the outer
            // get_variation still runs and must not fall back to URL-based slide matching.
            $currentForm.data('vasta-force-breed-featured-media', true);
        }

        if (hasCompleteSelection && get_variation($currentAllVariants, options)) {
            $('.btn-add-tocart').prop('disabled', false);
            $('.product-form-buttons-wrapper,.btn-add-tocart').removeClass('hide');
            $('.btn-choose-variant').addClass('hide');
            enableInputs($currentAllVariants.find('option:selected').val());
            if(parseInt(VastaShop.Variables._input_qtd.val()) == 1){
                VastaShop.Variables._bt_minus.attr('disabled','disabled');
            }
        }
        swatchLog('product_options.change END #' + debugId, {
            options: options,
            hasCompleteSelection: hasCompleteSelection,
            allVariantEnd: {
                id: $currentAllVariants.val(),
                dataOptions: $currentAllVariants.find('option:selected').attr('data-options') || null,
                image: $currentAllVariants.find('option:selected').attr('data-image') || null,
                imagePosition: $currentAllVariants.find('option:selected').attr('data-image-position') || null
            },
            swatchSnapshotEnd: getCurrentSwatchSnapshot($currentSwatchScope)
        });

        if (hasCompleteSelection && $currentAllVariants.val()) {
            scheduleSubscriptionPriceRefresh($currentAllVariants.val(), $currentForm[0]);
        }

        return false;
    });
    var temp = '$';
    // Choosed Variant

    function resolveVariantImageIndex(variant_image_position_raw, $currentVariantSelect) {
        var position = parseInt(variant_image_position_raw, 10);

        if (isNaN(position)) {
            return 0;
        }

        position = Math.max(position - 1, 0);

        // Keep support for pages that prepend a "test-image" slide.
        var hasTestImage = document.querySelector('.product-slider-featured img[alt*="test-image"], .jq-featured-slider img[alt*="test-image"]');
        var selectedValue = $(':selected', $currentVariantSelect).val();
        var isFirstVariant = $(':selected', $currentVariantSelect).is(':first-child') ||
            $('.all-variant option:enabled:first').val() === selectedValue;

        if (hasTestImage && isFirstVariant) {
            return 0;
        }

        if (hasTestImage) {
            return position + 1;
        }

        return position;
    }

    function syncVariantMediaByIndex(variantIndex) {
        if (window.productSplide) {
            var clearSplideProgrammaticFlag = function() {
                setTimeout(function() {
                    splideGoFromVariantChange = false;
                }, 420);
            };
            splideGoFromVariantChange = true;
            try {
                window.productSplide.go(variantIndex);
                clearSplideProgrammaticFlag();
            } catch (e) {
                setTimeout(function() {
                    try {
                        if (window.productSplide) {
                            splideGoFromVariantChange = true;
                            window.productSplide.go(variantIndex);
                        }
                    } catch (e2) {
                        splideGoFromVariantChange = false;
                    }
                    clearSplideProgrammaticFlag();
                }, 120);
            }
            return;
        }

        var $featuredSlider = _product_featured;
        if (!$featuredSlider.length) {
            return;
        }

        var goToSlide = function(retriesLeft) {
            if ($featuredSlider.hasClass('slick-initialized')) {
                $featuredSlider.slick('slickGoTo', variantIndex || 0);
                return;
            }

            if (retriesLeft > 0) {
                setTimeout(function() {
                    goToSlide(retriesLeft - 1);
                }, 150);
            }
        };

        goToSlide(8);
    }

    function normalizeImageUrl(url) {
        return (url || '').split('?')[0];
    }

    function extractImageFileKey(url) {
        var normalized = normalizeImageUrl(url).toLowerCase();
        if (!normalized) {
            return '';
        }

        var cleanPath = normalized.split('#')[0];
        var filename = cleanPath.split('/').pop() || '';

        // Shopify can append size suffixes like _300x, _600x600, _master before extension.
        filename = filename.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|[0-9]+x[0-9]*)(?=\.[a-z0-9]+$)/i, '');
        return filename;
    }

    function getThumbnailImageKeyForMediaPosition(position1) {
        var $thumb = $('#thumbnail-slider .splide__slide[data-forloop-index="' + position1 + '"] img').first();
        if (!$thumb.length) {
            return '';
        }
        var u = normalizeImageUrl($thumb.attr('src') || $thumb.attr('data-src') || '');
        if (!u || u.indexOf('data:image') === 0) {
            return '';
        }
        return extractImageFileKey(u);
    }

    function normalizeLooseText(text) {
        return (text || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function extractQuantityHints(text) {
        var normalized = normalizeLooseText(text);
        var bagMatch = normalized.match(/(\d+)\s*bags?/);
        var chewMatch = normalized.match(/(\d+)\s*chews?/);
        return {
            bag: bagMatch ? parseInt(bagMatch[1], 10) : null,
            chew: chewMatch ? parseInt(chewMatch[1], 10) : null
        };
    }

    function optionJoinedMatchesHints(joinedNorm, hints) {
        if (hints.bag !== null && !new RegExp('\\b' + hints.bag + '\\s*bags?\\b').test(joinedNorm)) {
            return false;
        }
        if (hints.chew !== null && !new RegExp('\\b' + hints.chew + '\\s*chews?\\b').test(joinedNorm)) {
            return false;
        }
        return true;
    }

    function getSlideVisualKeys(position1) {
        var keys = [];
        function addUrl(u) {
            var nu = normalizeImageUrl(u || '');
            if (!nu || nu.indexOf('data:image') === 0) {
                return;
            }
            var k = extractImageFileKey(nu);
            if (!k || keys.indexOf(k) !== -1) {
                return;
            }
            keys.push(k);
        }
        $('#main-slider .splide__slide.is-active img').each(function() {
            addUrl($(this).attr('src'));
            addUrl($(this).attr('data-src'));
        });
        $('#thumbnail-slider .splide__slide[data-forloop-index="' + position1 + '"] img').each(function() {
            addUrl($(this).attr('src'));
            addUrl($(this).attr('data-src'));
        });
        return keys;
    }

    function narrowCandidatesByPackContinuity($candidates, prevSecondOptionLabel) {
        if ($candidates.length <= 1) {
            return $candidates;
        }
        var tier = parsePackTierFromLabel(prevSecondOptionLabel || '');
        if (tier.bags === null && tier.chews === null) {
            return $candidates;
        }
        var $m = $candidates.filter(function() {
            var parts = ($(this).attr('data-options') || '').split(',');
            var o2 = (parts[1] || '').trim();
            var t2 = parsePackTierFromLabel(o2);
            if (tier.bags !== null && t2.bags === tier.bags) {
                return true;
            }
            if (tier.chews !== null && t2.chews === tier.chews) {
                return true;
            }
            return false;
        });
        return $m.length ? $m : $candidates;
    }

    function resolveMediaPosition1ForSplide(idx) {
        var $thumbSlide = $('#thumbnail-slider .splide__slide.is-active').first();
        var raw = $thumbSlide.attr('data-forloop-index');
        if (raw !== undefined && raw !== null && String(raw) !== '') {
            var p = parseInt(raw, 10);
            if (!isNaN(p)) {
                return p;
            }
        }
        return (typeof idx === 'number' && !isNaN(idx)) ? idx + 1 : 1;
    }

    function findVariantOptionForSplidePosition($all, $form, position1) {
        var currentOptsEarly = get_selected_options_by_swatch($form);
        var prevPackLabel = currentOptsEarly[1] || '';

        var $candidates = $all.find('option[data-image-position="' + position1 + '"]');
        var visualKeys = getSlideVisualKeys(position1);

        if ($candidates.length > 1 && visualKeys.length) {
            var $byVis = $candidates.filter(function() {
                var dk = extractImageFileKey(normalizeImageUrl($(this).attr('data-image')));
                return dk && visualKeys.indexOf(dk) !== -1;
            });
            if ($byVis.length === 1) {
                return $byVis.first();
            }
            if ($byVis.length > 0) {
                $candidates = $byVis;
            }
        }

        if (!$candidates.length && visualKeys.length) {
            $candidates = $all.find('option').filter(function() {
                var dk = extractImageFileKey(normalizeImageUrl($(this).attr('data-image')));
                return dk && visualKeys.indexOf(dk) !== -1;
            });
        }

        if (!$candidates.length) {
            return $();
        }

        var $activeSlide = $('#main-slider .splide__slide.is-active').first();
        var $img = $activeSlide.find('img').first();
        var slideUrl = normalizeImageUrl($img.attr('src') || $img.attr('data-src') || '');
        var slideKey = '';
        if (slideUrl && slideUrl.indexOf('data:image') !== 0) {
            slideKey = extractImageFileKey(slideUrl);
        }
        if (!slideKey) {
            slideKey = getThumbnailImageKeyForMediaPosition(position1);
        }
        if (slideKey && $candidates.length > 1) {
            var $byImg = $candidates.filter(function() {
                var vk = extractImageFileKey(normalizeImageUrl($(this).attr('data-image')));
                return vk && vk === slideKey;
            });
            if ($byImg.length === 1) {
                return $byImg.first();
            }
            if ($byImg.length > 0) {
                $candidates = $byImg;
            }
        }
        if ($candidates.length === 1) {
            return $candidates.first();
        }
        var imgAltRaw = ($img.attr('alt') || '').trim();
        var hintSource = (imgAltRaw || '') + ' ' + (slideKey || '') + ' ' + (slideUrl || '');
        var hints = extractQuantityHints(hintSource);
        if ((hints.bag !== null || hints.chew !== null) && $candidates.length > 1) {
            var $hintMatch = $candidates.filter(function() {
                var parts = ($(this).attr('data-options') || '').split(',');
                var joined = normalizeLooseText(parts.join(' '));
                return optionJoinedMatchesHints(joined, hints);
            });
            if ($hintMatch.length === 1) {
                return $hintMatch.first();
            }
            if ($hintMatch.length > 1) {
                $candidates = $hintMatch;
            }
        }
        if (imgAltRaw && $candidates.length > 1) {
            var altLower = imgAltRaw.toLowerCase().replace(/\s+/g, ' ');
            var $altMatch = $candidates.filter(function() {
                var parts = ($(this).attr('data-options') || '').split(',').map(function(s) {
                    return ((s || '').trim()).toLowerCase().replace(/\s+/g, ' ');
                });
                for (var pi = 0; pi < parts.length; pi++) {
                    if (parts[pi] && altLower.indexOf(parts[pi]) !== -1) {
                        return true;
                    }
                }
                return false;
            });
            if ($altMatch.length === 1) {
                return $altMatch.first();
            }
            if ($altMatch.length > 0) {
                $candidates = $altMatch;
            }
        }
        if ($candidates.length > 1) {
            $candidates = narrowCandidatesByPackContinuity($candidates, prevPackLabel);
        }
        if ($candidates.length === 1) {
            return $candidates.first();
        }
        var currentOpts = get_selected_options_by_swatch($form);
        var bestEl = null;
        var bestScore = -1;
        $candidates.each(function() {
            var parts = ($(this).attr('data-options') || '').split(',').map(function(s) {
                return (s || '').trim();
            });
            var score = 0;
            for (var k = 0; k < Math.min(parts.length, currentOpts.length); k++) {
                if (parts[k] === currentOpts[k]) {
                    score += (k === 0 ? 1 : 4);
                }
            }
            var tCand = parsePackTierFromLabel(parts[1] || '');
            var tPrev = parsePackTierFromLabel(prevPackLabel);
            if (tPrev.bags !== null && tCand.bags === tPrev.bags) {
                score += 10;
            }
            if (tPrev.chews !== null && tCand.chews === tPrev.chews) {
                score += 10;
            }
            if (score > bestScore) {
                bestScore = score;
                bestEl = this;
            }
        });
        return $(bestEl || $candidates[0]);
    }

    function attachProductSplideVariantSync() {
        if (!window.productSplide || window.productSplide.__vastaVariantSyncAttached) {
            return;
        }
        window.productSplide.__vastaVariantSyncAttached = true;
        window.productSplide.on('moved', function(newIndex, prevIndex, destIndex) {
            if (splideGoFromVariantChange) {
                return;
            }
            var idxCapture = typeof destIndex === 'number' ? destIndex : newIndex;
            setTimeout(function() {
                try {
                    var idx = idxCapture;
                    if (typeof idx !== 'number' || isNaN(idx)) {
                        idx = window.productSplide.index;
                    }
                    if (typeof idx !== 'number' || isNaN(idx)) {
                        idx = 0;
                    }
                    if (splideGoFromVariantChange) {
                        return;
                    }
                    var position1 = resolveMediaPosition1ForSplide(idx);
                    var $forms = $('form.jq-cart-add-product.form-add-to-cart');
                    if (!$forms.length) {
                        $forms = $('#product-swatch').closest('form');
                    }
                    if (!$forms.length) {
                        return;
                    }
                    var $firstAll = $forms.first().find('.all-variant').first();
                    if (!$firstAll.length) {
                        return;
                    }
                    var $firstForm = $firstAll.closest('form');
                    var $match = findVariantOptionForSplidePosition($firstAll, $firstForm, position1);
                    if (!$match.length) {
                        return;
                    }
                    var nextId = $match.val();
                    var optParts = ($match.attr('data-options') || '').split(',').map(function(s) {
                        return (s || '').trim();
                    });
                    if (optParts[0]) {
                        $forms.find('.swatch-type[data-index="1"]').data('vasta-prev-breed', optParts[0]);
                    }
                    suppressVariantMediaSliderDepth++;
                    try {
                        $forms.each(function() {
                            var $form = $(this);
                            var $all = $form.find('.all-variant').first();
                            if (!$all.length) {
                                return;
                            }
                            var $localMatch = $all.find('option').filter(function() {
                                return String($(this).val()) === String(nextId);
                            }).first();
                            if (!$localMatch.length) {
                                return;
                            }
                            if (String($all.val()) === String(nextId)) {
                                return;
                            }
                            applyVariantDomToSwatchUi($form, $localMatch);
                            $all.val(nextId).trigger('change');
                        });
                    } finally {
                        suppressVariantMediaSliderDepth--;
                    }
                } catch (err) {
                    swatchLog('splide moved variant sync error', err);
                }
            }, 0);
        });
    }

    function resolveVariantMediaIndexByImage($currentVariantSelect, $selectedOption) {
        var targetImage = normalizeImageUrl($selectedOption.attr('data-image'));
        if (!targetImage) {
            return null;
        }
        var targetImageKey = extractImageFileKey(targetImage);

        // Try thumbnail slider first (usually has stable order/index attributes).
        var thumbIndex = null;
        $('.product-slider-thumbnails .product-slide, #thumbnail-slider .splide__slide[data-forloop-index], .slider-thumbnails .splide__slide[data-forloop-index]').each(function() {
            var $img = $(this).find('img.slick-img, img').first();
            var imgSrc = normalizeImageUrl($img.attr('src') || $img.attr('data-src') || '');
            var imgDataLazy = normalizeImageUrl($img.attr('data-lazy') || '');
            var imgSrcset = ($img.attr('srcset') || '').split(',')[0] || '';
            var imgSrcsetUrl = normalizeImageUrl(imgSrcset.trim().split(' ')[0] || '');
            var possibleSources = [imgSrc, imgDataLazy, imgSrcsetUrl];

            var hasMatch = possibleSources.some(function(source) {
                if (!source) {
                    return false;
                }
                if (source === targetImage) {
                    return true;
                }
                return targetImageKey && extractImageFileKey(source) === targetImageKey;
            });

            if (hasMatch) {
                var dataIndex = parseInt($(this).attr('data-forloop-index'), 10);
                if (!isNaN(dataIndex)) {
                    thumbIndex = Math.max(dataIndex - 1, 0);
                    return false;
                }
            }
            return true;
        });

        if (thumbIndex !== null) {
            return thumbIndex;
        }

        // Fallback: match directly in featured slider images.
        var featuredIndex = null;
        $('#main-slider .splide__slide img, .product-slider-featured .product-slide img, .jq-featured-slider .slick-slide img, .jq-featured-slider .splide__slide img').each(function(index) {
            var $img = $(this);
            var imgSrc = normalizeImageUrl($img.attr('src') || $img.attr('data-src') || '');
            var imgDataLazy = normalizeImageUrl($img.attr('data-lazy') || '');
            var imgSrcset = ($img.attr('srcset') || '').split(',')[0] || '';
            var imgSrcsetUrl = normalizeImageUrl(imgSrcset.trim().split(' ')[0] || '');
            var possibleSources = [imgSrc, imgDataLazy, imgSrcsetUrl];
            var hasMatch = possibleSources.some(function(source) {
                if (!source) {
                    return false;
                }
                if (source === targetImage) {
                    return true;
                }
                return targetImageKey && extractImageFileKey(source) === targetImageKey;
            });

            if (hasMatch) {
                featuredIndex = index;
                return false;
            }
            return true;
        });

        return featuredIndex;
    }

    _choosed_variant.change(function() {
        try {
            var debugId = ++swatchDebugCounter;
            var $currentVariantSelect = $(this);
            $('#add-to-cart-error').addClass('hide');
            var $selectedOption = $(':selected', this);
            var variant_id = $selectedOption.val();
            if (!variant_id) {
                return;
            }

            var variant_image_position = $selectedOption.attr('data-image-position');
            swatchLog('all-variant.change START #' + debugId, {
                variantId: variant_id,
                dataOptions: $selectedOption.attr('data-options') || null,
                dataImage: $selectedOption.attr('data-image') || null,
                dataImagePosition: variant_image_position || null,
                swatchSnapshot: getCurrentSwatchSnapshot($currentVariantSelect.closest('form'))
            });
            var variant_price = $selectedOption.attr('data-price');
            var variant_inventory = parseInt($selectedOption.attr('data-inventory'));
            var variant_available = $selectedOption.attr('data-available');
            var variant_compare_at_price = $selectedOption.attr('data-compare-at-price') === "" ? "" : VastaShop.formatMoney(parseInt($selectedOption.attr('data-compare-at-price')), money_format) ;
            var compare_at_price = $selectedOption.attr('data-compare-at-price') === "" ? "" : parseInt($selectedOption.attr('data-compare-at-price')) ;
            const $priceunit = $('.price-per-unit-edits');
            var subscriptionPricingActive = isPdpSubscriptionActive($currentForm);

            syncPageVariantSelects(variant_id, $currentVariantSelect);

            $priceunit.hide();
            $priceunit.filter('[data-variant = "' + variant_id + '"]').show();

            var $currentForm = $currentVariantSelect.closest('form');
            var $currentQuantityInput = $currentForm.find('.product-quantity-wrapper > .quantity');
            var currentQuantityValue = parseInt($currentQuantityInput.val(), 10);

            if (isNaN(currentQuantityValue) || currentQuantityValue < 1) {
                currentQuantityValue = 1;
            }

            if (variant_inventory !== -1 && currentQuantityValue > variant_inventory) {
                currentQuantityValue = variant_inventory;
            }

            $currentQuantityInput.val(currentQuantityValue);

            var forceBreedFeaturedMedia = !!$currentForm.data('vasta-force-breed-featured-media');
            if (forceBreedFeaturedMedia) {
                $currentForm.removeData('vasta-force-breed-featured-media');
            }

            var variantIndexFromImage = null;
            if (!forceBreedFeaturedMedia) {
                variantIndexFromImage = resolveVariantMediaIndexByImage($currentVariantSelect, $selectedOption);
            }
            swatchLog('all-variant.change image resolve #' + debugId, {
                forceBreedFeaturedMedia: forceBreedFeaturedMedia,
                variantIndexFromImage: variantIndexFromImage,
                variantImagePositionRaw: variant_image_position
            });
            if (suppressVariantMediaSliderDepth <= 0 && !pdpSkipInitialMediaSync) {
                if (forceBreedFeaturedMedia) {
                    var featuredSlideIndex = resolveVariantImageIndex(variant_image_position, $currentVariantSelect);
                    swatchLog('all-variant.change breed featured index #' + debugId, {
                        featuredSlideIndex: featuredSlideIndex
                    });
                    syncVariantMediaByIndex(featuredSlideIndex);
                } else if (variantIndexFromImage !== null) {
                    syncVariantMediaByIndex(variantIndexFromImage);
                } else if (variant_image_position !== undefined && variant_image_position !== null && variant_image_position !== '') {
                    var variantIndex = resolveVariantImageIndex(variant_image_position, $currentVariantSelect);
                    swatchLog('all-variant.change fallback image index #' + debugId, {
                        fallbackVariantIndex: variantIndex
                    });
                    syncVariantMediaByIndex(variantIndex);
                }
            }

            variant_price = window.vastaApplyScheduledPdpDiscount(parseInt(variant_price), $currentForm[0]);
            compare_at_price = parseInt(compare_at_price !== '' ? compare_at_price: 0);

            // Old Layout
            var p_number = document.getElementById("p_number");
            var numero = 1;
            if (p_number && p_number.innerText) {
                var valor = p_number.innerText;
                var parsedNumero = parseFloat(valor);
                if (!isNaN(parsedNumero) && parsedNumero > 0) {
                    numero = parsedNumero;
                }
            }
            if (!subscriptionPricingActive) {
                if (_current_price.length > 0) {
                    _current_price.html(VastaShop.formatMoney(variant_price));
                    $('.widget-price').html(VastaShop.formatMoney(variant_price/numero));
                }

                if (_current_compare_price.length > 0) {
                    _current_compare_price.html(VastaShop.formatMoney(compare_at_price));
                }

                if (_new_current_price.length > 0) {
                    _new_current_price.html(VastaShop.formatMoney(variant_price).replace(/[^0-9,.]/gi, ''));
                }

                if (_new_current_compare_price.length > 0) {
                    _new_current_compare_price.html(VastaShop.formatMoney(compare_at_price));
                }
                $('[id="product-price"]').attr('data-product-price', variant_price);

                if (variant_price < compare_at_price) {
                    _current_compare_price.show();
                } else {
                    _current_compare_price.empty().hide();
                }
            }

            _price = window.vastaApplyScheduledPdpDiscount($(':selected', $currentVariantSelect).attr('data-price'), $currentForm[0]);
            var packTierActive = formHasPackTierOptions($currentForm);
            var packLineQty = currentQuantityValue;
            if (packTierActive && typeof window.vastaGetPdpLineQuantityForPricing === 'function') {
                var pricedQty = window.vastaGetPdpLineQuantityForPricing($currentForm[0]);
                if (pricedQty !== null) {
                    packLineQty = pricedQty;
                }
            }
            if (!subscriptionPricingActive) {
                _add_to_cart_value.html(VastaShop.formatMoney(parseInt(packLineQty, 10) * parseInt(_price, 10)));
            }
            $currentQuantityInput.attr('data-max', variant_inventory);
            inventoryControl(variant_id);
            enableInputs(variant_id);
            if (parseInt(currentQuantityValue) == 1 ){
                $currentQuantityInput.siblings('.btn-minus').attr('disabled','disabled');
            }
            quantity = currentQuantityValue;
            price    = parseInt($('.product-variant[name="id"] option:selected').data('price'));
            you_save(compare_at_price,parseInt(variant_price));
            if (packTierActive) {
                var packTier = getSelectedPackTier($currentForm);
                var packCountType = getPackCountTypeFromTier(packTier) || 'bags';
                var labelBagCount = parseInt(currentQuantityValue, 10) || getPackUnitCount(packTier);
                updatePdpAddToCartPackLabel($currentForm, labelBagCount, packCountType);
            } else if(quantity > 1) {
                $(_add_to_cart_items).html(quantity + " ITEMS")
            } else {
                $(_add_to_cart_items).html(quantity + " ITEM")
            }

            scheduleSubscriptionPriceRefresh(variant_id, $currentForm[0]);

            document.dispatchEvent(new CustomEvent('variantChanged', {
                detail: { variantId: variant_id, form: $currentForm[0] }
            }));

            if ('true' === variant_available) {
                $currentForm.find('.product-quantity,#AddToCart2,#AddToCart,#AddToCart3').show().removeClass('hide');
                $currentForm.find("[id='button-out-of-stock'], #button-out-of-stock-2, #tabs-button-out-of-stock").hide().addClass('hide');
            } else {
                $currentForm.find('.product-quantity,#AddToCart2,#AddToCart,#AddToCart3').hide().addClass('hide');
                $currentForm.find("[id='button-out-of-stock'], #button-out-of-stock-2, #tabs-button-out-of-stock").show().removeClass('hide');
            }
            swatchLog('all-variant.change END #' + debugId, {
                variantId: variant_id,
                variantAvailable: variant_available,
                currentPrice: variant_price,
                compareAtPrice: compare_at_price
            });

            
        } catch(e){
            console.error('[SWATCH_DEBUG] all-variant.change ERROR', e);
        }
    });

    $(document).ready(function(){
        $('form.jq-cart-add-product.form-add-to-cart').each(function() {
            initPrevBreedFromForm($(this));
        });
        if (!$('form.jq-cart-add-product').length) {
            initPrevBreedFromForm($('#product-swatch').closest('form'));
        }
        var splideAttachAttempts = 0;
        function tryAttachSplideVariantSync() {
            if (window.productSplide && !window.productSplide.__vastaVariantSyncAttached) {
                attachProductSplideVariantSync();
            }
            if (!window.productSplide || !window.productSplide.__vastaVariantSyncAttached) {
                splideAttachAttempts += 1;
                if (splideAttachAttempts < 60) {
                    setTimeout(tryAttachSplideVariantSync, 75);
                }
            }
        }
        tryAttachSplideVariantSync();

        $('.swatch-type[data-index="1"] .swatch-element').each(function(){
            if (Object.keys(VastaShop.Product.current.variations).indexOf($(this).attr('data-swatch')) > -1) {
                $(this).removeClass('swatch-disabled').find('input').prop('disabled', false);
            } else {
                $(this).find(".tooltip").remove();
            }
        });

        $('.swatch-type[data-index="1"] .jq-product-variant option').each(function(){
            if (Object.keys(VastaShop.Product.current.variations).indexOf($(this).attr('value')) < 0 && $(this).attr('value') !== '') {
                $(this).prop('disabled', true);
            }
        });

       

        pdpSkipInitialMediaSync = true;

        if (VastaShop.Product.options.length > 0) {
            VastaShop.Product.options.forEach(function(option){
                var productVariation = option.replace(/"/g, '\\"').replace(/'/g, "\\'");
                $('.swatch-element[data-swatch="' + productVariation + '"]').trigger('click');
                $('.product-variant option[value="' + productVariation + '"]').parent().val(productVariation.replace(/\\/gi, '')).trigger('change');
            });
        }

        pdpSkipInitialMediaSync = false;

        if (prepare_variants($('.swatch-variant-value:checked', $('.swatch-element'))).length == VastaShop.Product.current.options.length) {
            var initialVariantId = $(':selected', _choosed_variant).val();
            if (!isPdpSubscriptionActive(null)) {
                _price = window.vastaApplyScheduledPdpDiscount($(':selected', _choosed_variant).attr('data-price'));
                _current_price.html(VastaShop.formatMoney(_price));
                $('[id="product-price"]').attr('data-product-price', _price);
                _current_compare_price.html(_global_variant_compare_at_price);
                _add_to_cart_value.html(VastaShop.formatMoney(parseInt(_quantity.val()) * _price));
            }
            scheduleSubscriptionPriceRefresh(initialVariantId, null);
        }

        $('.modal-close').click(function(){
            $('.modal-container').removeClass('active');
            $('html, body').removeClass('sizechart-open');
        });

        $(window).click(function(e){
            if (e.target == $('.modal-container').get(0)) {
                $('.modal-container').removeClass('active');
                $('html, body').removeClass('sizechart-open');
            }
        });

        for (var i = 2, j = VastaShop.Product.current.options.length+1; i < j; i++) {
            choose_before_option( i );
        }

        if (typeof window.vastaRefreshPdpPackDisplay === 'function') {
            window.vastaRefreshPdpPackDisplay();
        }

        getPdpForms().on('submit', function() {
            var $form = $(this);
            var $qty = $form.find('.product-quantity-wrapper > .quantity');
            if (!$qty.length || !pdpQuantityMatchesPackTier($form)) {
                return;
            }
            var displayQty = $qty.val();
            $qty.data('vasta-pack-display-qty', displayQty);
            $qty.val(1);
            setTimeout(function() {
                $qty.val($qty.data('vasta-pack-display-qty') || displayQty);
            }, 0);
        });
    });
})();